import { List, ListItem, ListItemText, Chip, Typography, Box } from '@mui/material';

const CATEGORY_COLORS = {
  'Museo': '#1976d2',
  'Parque': '#43a047',
  'Plaza': '#fbc02d',
  'Iglesia': '#9c27b0',
  'Balneario': '#00bcd4',
  'Mirador': '#ff9800',
  'Cultural': '#795548',
};
function getCategoryColor(category) {
  return CATEGORY_COLORS[category] || '#1976d2';
}

export default function Sidebar({ places = [], onSelect, searchQuery }) {
  const hasSearch = (searchQuery || '').trim().length > 0;
  return (
    <Box
      sx={{
        width: 320,
        maxWidth: '100%',
        height: '100%',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        boxShadow: '2px 0 12px rgba(0,0,0,0.06)',
      }}
    >
      <Box sx={{ px: 2, pt: 2.5, pb: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main', mb: 0.5 }}>
          Lugares de interés
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {hasSearch
            ? `Mostrando ${places.length} resultado${places.length !== 1 ? 's' : ''}`
            : 'Seleccioná un lugar para ver más información'}
        </Typography>
      </Box>
      <List disablePadding sx={{ px: 1 }}>
        {places.length === 0 ? (
          <Box sx={{ py: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {hasSearch ? 'No se encontraron lugares con ese criterio.' : 'No hay lugares cargados.'}
            </Typography>
          </Box>
        ) : places.map((place) => (
          <ListItem
            key={place.id}
            onClick={() => onSelect(place)}
            sx={{
              py: 1.25,
              px: 1.5,
              borderRadius: 1.5,
              mb: 0.5,
              '&:hover': { bgcolor: 'action.hover' },
            }}
            button
          >
            <Box
              component="span"
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: getCategoryColor(place.category),
                mr: 1.5,
                flexShrink: 0,
              }}
            />
            <ListItemText
              primary={place.title}
              primaryTypographyProps={{ fontWeight: 600, fontSize: '0.95rem' }}
              secondary={<Chip label={place.category} size="small" sx={{ mt: 0.5 }} />}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
} 